<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-list">
    <vx-card ref="filterCard" title="Filters" class="user-list-filters mb-8">
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Device</label>
          <v-select
            :options="deviceList"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="filter.device"
            @search="searchDevice"
            class="mb-4 md:mb-0"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Filter</label>
          <v-select
            :options="dateList"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="filter.dateOption"
            class="mb-2 md:mb-0"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="vs-input--label">Start Time</label>
          <flat-pickr
            :disabled="disableDate"
            :config="{
              enableTime: true,
              dateFormat: 'Y-m-d H:i',
              maxDate: maxDate,
              time_24hr: true,
              defaultHour: 0
            }"
            style="width: 100%"
            v-model="filter.start_time"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="vs-input--label">End Time</label>
          <flat-pickr
            :disabled="disableDate"
            :config="{
              enableTime: true,
              dateFormat: 'Y-m-d H:i',
              maxDate: maxDate,
              time_24hr: true,
              defaultHour: 23,
              defaultMinute: 59
            }"
            style="width: 100%"
            v-model="filter.end_time"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <vs-button
            id="searchBtn"
            style="width: 100%"
            color="success"
            type="filled"
            icon-pack="feather"
            icon="icon-search"
            class="pl-5 mt-1 vs-con-loading__container"
            @click="search"
            >Search</vs-button
          >
        </div>
      </div>
    </vx-card>

    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <div class="flex-grow">
          <vs-button
            v-if="data.length > 0"
            id="exportBtn"
            icon-pack="feather"
            icon="icon-file-text"
            color="success"
            type="border"
            class="mb-4 md:mb-0 vs-con-loading__container"
            @click="exportReport"
            >Export</vs-button
          >
        </div>

        <vs-dropdown vs-trigger-click class="cursor-pointer mr-2">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ page * per_page - (per_page - 1) }} -
              {{
                row_total - page * per_page > 0 ? page * per_page : row_total
              }}
              of {{ row_total }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="updatePerPage(10)">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(25)">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(50)">
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(100)">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
      <div class="table-container">
        <table class="table">
          <thead>
            <tr>
              <th>No</th>
              <th>Imei</th>
              <th>Plate</th>
              <th>Start Time</th>
              <th>End Time</th>
              <th>Days</th>
              <th>Driving Behavior</th>
              <th>
                Driving Behavior Average
                <br />
                <span style="font-size: 12px; font-weight: 600"
                  >( Driving Behavior / Days )</span
                >
              </th>
              <th>Driving Behavior Grade</th>
              <th class="text-center">Detail Charts</th>
            </tr>
          </thead>
          <tbody v-if="loading">
            <tr>
              <td colspan="15" class="text-center">Loading....</td>
            </tr>
          </tbody>
          <tbody v-else-if="datatable.length > 0">
            <tr v-for="(item, index) in datatable" :key="index">
              <td>{{ (page - 1) * per_page + (index + 1) }}</td>
              <td>{{ item.imei }}</td>
              <td>{{ item.plate }}</td>
              <td>{{ filter.start_time }}</td>
              <td>{{ filter.end_time }}</td>
              <td>{{ jumlah_hari }} Days</td>
              <td>{{ item.total }}</td>
              <td>{{ item.averange }}</td>
              <td :style="`font-weight: 700; color: ${item.color}`">
                {{ item.result }}
              </td>
              <td class="text-center">
                <center>
                  <vx-tooltip text="Driving Behavior Chart" position="top">
                    <vs-button
                      type="border"
                      size="small"
                      icon-pack="feather"
                      icon="icon-bar-chart-2"
                      color="primary"
                      class="mr-2 vs-con-loading__container"
                      @click="chart(item.plate, item.imei)"
                    ></vs-button>
                  </vx-tooltip>
                </center>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="15" class="text-center">No Data Available</td>
            </tr>
          </tbody>
        </table>

        <vs-pagination :total="n_page" v-model="page"></vs-pagination>
      </div>

      <vs-popup
        class="vs-popup-lg"
        classContent="popup-example"
        :title="popupTitle"
        :active.sync="showPopup"
      >
        <template>
          <div class="vx-row mb-6">
            <div class="vx-col w-full mb-base">
              <vue-apex-charts
                type="bar"
                height="400"
                :options="lineChartSimple.chartOptions"
                :series="lineChartSimple.series"
              ></vue-apex-charts>
              <template slot="codeContainer"> </template>
            </div>
            <div class="vx-col w-full">
              <div
                style="display: block; overflow-x: auto; white-space: nowrap"
              >
                <table class="table" style="width: 150%">
                  <thead>
                    <tr>
                      <th style="width: 4%">No</th>
                      <th style="width: 7%">Date</th>
                      <th style="width: 12%">Driver Name</th>
                      <th
                        v-for="(alarm, th_alert) in list_alert"
                        :key="th_alert"
                        v-show="alarm.description"
                      >
                        {{ alarm.description }}
                      </th>
                    </tr>
                  </thead>
                  <tbody v-if="loading">
                    <tr>
                      <td colspan="15" class="text-center">Loading....</td>
                    </tr>
                  </tbody>
                  <tbody v-else-if="table_grafik.length > 0">
                    <tr v-for="(item, index) in table_grafik" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ item.date }}</td>
                      <td>{{ item.driver_name }}</td>
                      <td
                        v-for="(alarm, td_alert) in list_alert"
                        :key="td_alert"
                        v-show="alarm.description"
                      >
                        <template v-if="JSON.parse(item.score)[td_alert]">
                          <table border="0">
                            <thead>
                              <tr>
                                <th style="font-size: 12px">Driving Alert</th>
                                <th style="font-size: 12px">Alert Score</th>
                                <th style="font-size: 12px">
                                  Driving Behavior
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td
                                  style="
                                    font-size: 16px;
                                    font-weight: 600;
                                    text-align: center;
                                  "
                                >
                                  {{
                                    JSON.parse(item.score)[td_alert].total_alarm
                                  }}
                                </td>
                                <td
                                  style="
                                    font-size: 16px;
                                    font-weight: 600;
                                    text-align: center;
                                  "
                                >
                                  {{
                                    JSON.parse(item.score)[td_alert].score_alarm
                                  }}
                                </td>
                                <td
                                  style="
                                    font-size: 16px;
                                    font-weight: 600;
                                    text-align: center;
                                  "
                                >
                                  {{
                                    JSON.parse(item.score)[td_alert].total_point
                                  }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </template>
                        <!-- <template v-else>
                          <span>&nbsp;</span>
                        </template> -->
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="15" class="text-center">
                        No Data Available
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="vx-row mb-5"></div>
        </template>
      </vs-popup>
    </div>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'
import FileDownload from 'js-file-download'
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    flatPickr,
    vSelect,
    VueApexCharts
  },

  data() {
    return {
      lineChartSimple: {
        series: [],
        chartOptions: {
          noData: {
            text: 'No Data'
          },
          chart: {
            height: 350,
            zoom: {
              enabled: false
            }
          },
          colors: [
            '#468ffb',
            '#5de496',
            '#F3AF1A',
            '#EE4360',
            '#775DD0',
            '#684242'
          ],
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'straight'
          },
          title: {
            text: 'Driving Behavior Chart',
            align: 'left'
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            }
          },
          xaxis: {
            categories: []
          }
        }
      },

      data: [],
      data_imei: [],
      list_alert: [],
      jumlah_hari: 0,
      driving_score: [],
      grade_score: [
        'Best Driver',
        'Good Driver',
        'Satisfactory Driver',
        'Driver Need Improvement'
      ],
      color_score: ['#468ffb', '#5de496', '#F3AF1A', '#EE4360'],
      token: '',
      action: '',
      loading: false,
      actor: '',
      tempId: 0,
      disableDate: true,
      popupTitle: '',
      showPopup: false,

      filter: {
        device: '',
        start_time: null,
        end_time: null,
        dateOption: { value: '', label: '-- Select Filter --' }
      },

      filtered: {
        device: '',
        start_time: null,
        end_time: null,
        dateOption: { value: '', label: '-- Select Filter --' }
      },

      deviceList: [],
      dateList: [
        { value: '', label: '-- Select Filter --' },
        // { value: 'today', label: 'Today' },
        { value: 'yesterday', label: 'Yesterday' },
        { value: 'define', label: 'Select Date' }
      ],

      driving_behavior: [],
      datatable: [],
      table_grafik: [],

      page: 1,
      per_page: 10,
      row_total: 0,
      keyword: '',

      timer: null,
      notify: 'Server Error',
      today: '',
      yesterday: '',
      twoDaysAgo: '',
      maxDate: '',

      resultTotal: '',
      resultColor: ''
    }
  },

  computed: {
    n_page() {
      return Math.ceil(this.row_total / this.per_page)
    },

    dateOption() {
      return this.filter.dateOption ? this.filter.dateOption.value : ''
    }
  },

  watch: {
    page() {
      this.datatable = this.driving_behavior.slice(
        (this.page - 1) * this.per_page,
        this.page * this.per_page
      )
    },

    per_page() {
      if (this.page != 1) this.page = 1
      else this.initTable()
    },

    dateOption() {
      let today = new Date()
      let yesterday = new Date(today)

      yesterday.setDate(yesterday.getDate() - 1)
      today = this.formatDate(today.toDateString())
      yesterday = this.formatDate(yesterday.toDateString())

      this.disableDate = true
      // if (this.dateOption == 'today') {
      //   this.filter.start_time = this.today + ' 00:00'
      //   this.filter.end_time = this.today + ' 23:59'
      //   this.maxDate = this.today + ' 23:59'
      // } else
      if (this.dateOption == 'yesterday') {
        this.filter.start_time = this.yesterday + ' 00:00'
        this.filter.end_time = this.yesterday + ' 23:59'
        this.maxDate = this.yesterday + ' 23:59'
      } else {
        this.filter.start_time = ''
        this.filter.end_time = ''
        this.maxDate = this.yesterday + ' 23:59'
        // this.maxDate = this.twoDaysAgo + ' 23:59'
        this.disableDate = false
      }
    }
  },

  created() {
    let today = new Date()
    let yesterday = new Date(today)
    let twoDaysAgo = new Date(today)

    yesterday.setDate(yesterday.getDate() - 1)
    twoDaysAgo.setDate(twoDaysAgo.getDate() - 2)

    // this.today = this.formatDate(today.toDateString())
    this.yesterday = this.formatDate(yesterday.toDateString())
    this.twoDaysAgo = this.formatDate(twoDaysAgo.toDateString())

    // this.maxDate = this.twoDaysAgo
    // this.maxDate = `${this.today} 23:59`

    this.token =
      localStorage.getItem('userInfo') !== null
        ? JSON.parse(localStorage.getItem('userInfo')).token
        : ''

    this.$http
      .get(`${this.$api.endpoint}/user/profile`, {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      })
      .then((res) => {
        this.actor = res.data.message.data
        this.searchDevice('')
      })
      .catch((error) => {
        this.$gf.httpErrorHandler(error)
      })

    // this.initTable()
    // this.getDrivingScore()
  },

  methods: {
    updatePerPage(n) {
      this.per_page = n
    },

    emptyData() {
      this.data = []
      this.data_imei = []
      this.driving_behavior = []
      this.row_total = 0
      this.datatable = []
    },

    formatDate(date) {
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear()

      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day

      return [year, month, day].join('-')
    },

    searchDevice(keyword) {
      if (this.actor.privilege >= 4) {
        this.getDataDevice(keyword)
      } else {
        if (keyword.length >= 3) {
          this.getDataDevice(keyword)
        } else {
          this.deviceList = []
        }
      }
    },

    getDataDevice(keyword) {
      this.$http
        .get(
          `${this.$api.endpoint}/tracking/search?keyword=${keyword}&type=vehicle`,
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          var deviceList = res.data.message.data
          const allDevice = [{ label: '-- All Device --', value: 'all' }]

          if (this.actor.privilege >= 4) {
            this.deviceList = allDevice.concat(deviceList)
          } else {
            this.deviceList = res.data.message.data
          }
          // console.log(this.deviceList)
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    getDrivingScore(device) {
      this.$http
        .get(`${this.$api.endpoint}/driving_scoring/list`, {
          params: {
            device: device
          },
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.driving_score = res.data.message.data
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    initTable() {
      this.getDrivingScore(this.filter.device ? this.filter.device.value : '')
      this.driving_behavior = []
      this.loading = true
      this.$http
        .get(`${this.$api.endpoint}/report/driving_behavior/data`, {
          params: {
            page: this.page,
            per_page: this.per_page,
            start: this.filter.start_time,
            end: this.filter.end_time,
            device: this.filter.device ? this.filter.device.value : ''
          },

          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.loading = false
          this.$vs.loading.close(`#searchBtn > .con-vs-loading`)

          if (res.data.status) {
            this.data = res.data.data
            this.data_imei = res.data.data_distinct
            this.jumlah_hari = res.data.jumlah_hari
            this.list_alert = res.data.list_alert

            this.data_imei.map((val) => {
              let total = 0
              let averange = 0
              this.data.map((val2) => {
                if (val.imei == val2.imei) {
                  let score = JSON.parse(val2.score)
                  for (let y = 0; y < score.length; y++) {
                    total = total + score[y].total_point
                  }
                }
              })

              averange = total != 0 ? total / this.jumlah_hari : 0
              this.cekDrivingScore(Math.round(averange))

              this.driving_behavior.push({
                imei: val.imei,
                plate: val.plate,
                total: total,
                averange: Math.round(averange),
                result: this.resultTotal,
                color: this.resultColor
              })
            })

            this.driving_behavior.sort(this.sortDrivingBehavior)

            this.row_total = this.driving_behavior.length

            this.datatable = this.driving_behavior.slice(
              (this.page - 1) * this.per_page,
              this.page * this.per_page
            )
          } else {
            this.emptyData()
          }
        })
        .catch((error) => {
          console.log(error)
          this.emptyData()
          this.loading = false
          this.$vs.loading.close(`#searchBtn > .con-vs-loading`)
          this.$gf.httpErrorHandler(error)
        })
    },

    cekDrivingScore(averange) {
      let grade = ''
      let color = ''

      this.driving_score.map((val) => {
        if (averange >= val.min_score && averange <= val.max_score) {
          grade =
            this.grade_score[val.grade] +
            ` ( DBS: ${val.min_score} - ${val.max_score})`

          color = this.color_score[val.grade]
        }
      })

      if (grade != '') {
        this.resultTotal = grade
        this.resultColor = color
      } else {
        if (averange == 0) {
          this.resultTotal = this.grade_score[0]
          this.resultColor = this.color_score[0]
        } else {
          this.resultTotal = this.grade_score[3]
          this.resultColor = this.color_score[3]
        }
      }
    },

    chart(plate, imei) {
      this.popupTitle = `Plate : ${plate}`
      this.showPopup = true

      // ============ START PROCESS DATA UNTUK TABLE DETAIL CHART ==============

      this.table_grafik = []
      let data_categories = []

      this.data.map((val) => {
        if (imei == val.imei) {
          this.table_grafik.push(val)
          data_categories.push(val.date)
        }
      })

      this.table_grafik.map((val, i) => {
        let temp_alert_score = []
        let alert_scores = JSON.parse(val.score)

        this.list_alert.map((val2) => {
          const res = alert_scores.findIndex(
            (item) => val2.description === item.alert
          )

          if (res > -1) {
            temp_alert_score.push(alert_scores[res])
          } else {
            temp_alert_score.push({
              alert: val2.description,
              score_alarm: '-',
              total_alarm: '-',
              total_point: '-'
            })
          }
        })

        this.table_grafik[i].score = JSON.stringify(temp_alert_score)
      })

      this.table_grafik.sort(this.sortChart)

      // ============ END PROCESS DATA UNTUK TABLE DETAIL CHART ==============

      // ============ START PROCESS DATA UNTUK DIAGRAM DETAIL CHART ==============

      let series = []
      this.list_alert.map((val) => {
        let temp_data = []
        let alert_name = val.description
        this.data.map((val2) => {
          let alert_scores = JSON.parse(val2.score)
          const res = alert_scores.findIndex(
            (score) => score.alert === val.description
          )
          if (res > -1) {
            temp_data.push(alert_scores[res].total_point)
          } else {
            temp_data.push(0)
          }
        })

        series.push({
          name: alert_name,
          data: temp_data
        })
      })

      this.lineChartSimple.chartOptions = {
        ...this.lineChartSimple.chartOptions,
        ...{
          noData: {
            text: ''
          }
        }
      }

      this.lineChartSimple.chartOptions = {
        ...this.lineChartSimple.chartOptions,
        ...{
          xaxis: {
            categories: data_categories
          }
        }
      }

      this.lineChartSimple.series = series

      // ============ END PROCESS DATA UNTUK DIAGRAM DETAIL CHART ==============
    },

    sortDrivingBehavior(a, b) {
      return b.averange - a.averange
    },

    sortChart(a, b) {
      if (a.date < b.date) {
        return -1
      }
      if (a.date > b.date) {
        return 1
      }
      return 0
    },

    search() {
      this.loading = true
      this.$vs.loading({
        background: 'success',
        color: '#fff',
        container: '#searchBtn',
        scale: 0.45
      })

      this.filtered.device = this.filter.device
      this.filtered.start_time = this.filter.start_time
      this.filtered.end_time = this.filter.end_time

      this.page = 1
      this.initTable()
    },

    exportReport() {
      this.$vs.loading({
        background: 'success',
        color: '#fff',
        container: '#exportBtn',
        scale: 0.45
      })

      this.$http
        .get(`${this.$api.endpoint}/report/driving_behavior/export`, {
          responseType: 'blob',
          params: {
            device: this.filtered.device ? this.filtered.device.value : '',
            start: `${this.filtered.start_time}:00`,
            end: `${this.filtered.end_time}:00`,
            driving_score: this.driving_score
          },

          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.$vs.loading.close(`#exportBtn > .con-vs-loading`)

          let filename = `Driving_behavior_${this.filtered.start_time
            .toString()
            .substr(0, 10)}_${this.filtered.end_time
            .toString()
            .substr(0, 10)}.xlsx`
          FileDownload(res.data, filename)
        })
        .catch((error) => {
          this.$vs.loading.close(`#exportBtn > .con-vs-loading`)
          this.$gf.httpErrorHandler(error)
        })
    }
  }
}
</script>
